import Delete from "csi/table/Delete";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import PPAttributeTable from "src/ProductPresentation/PPAttributeTable";
import FilterAttributesTable from "src/SiteAdmin/FilterAttributes/FilterAttributesTable";

const _AttributeDeleteMixin = declare(Delete, {

	/**
	 * @override
	 * Delete key from key container.
	 */
	toWriter(): void {
		// get key container url
		const keyContainerUrl =
		(this.widget as
			typeof FilterAttributesTable.prototype &
			typeof PPAttributeTable.prototype
		)
			.getKeyContainerUrl();

		// get node with key to delete
		const deleteNode = this.getNode();

		this.m_writer
			.changeNode(keyContainerUrl)
			.changeAttribute("Keys", xml.ATTR_STRINGMAP, { 0: deleteNode.Key }, false, true);
	},
});

export = _AttributeDeleteMixin;